module.exports = __webpack_public_path__ + "static/ppc_hero-0454ee2e6658eb32530903d840218e50.jpeg";